import React, { useEffect, useState } from "react";
import "./WhatsApp.scss";
import heroImg from "../Assets/images/whatsapp-img.png";
import PhoneNumberInput from "./Input/PhoneInput";
import { createWhatsappQuery } from "../services/createWhatsappQuery";

const WhatsAppCMP = () => {
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("in"); 
  const [countryName, setCountryName] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetCount, setResetCount] = useState(0);
  const isButtonDisabled = !phone || loading;

  useEffect(() => {
  if (error || success) {
    const timer = setTimeout(() => {
      setError("");
      setSuccess("");
    }, 10000);

    return () => clearTimeout(timer);
  }
}, [error, success]);

  const handleSubmit = async () => {
    setError("");
    setSuccess("");

    if (!phone) {
      setError("Phone number is required");
      return;
    }

    try {
      setLoading(true);
      const payload = { mobileNo: phone,country:countryName };
      const response = await createWhatsappQuery(payload);

      setSuccess(response?.message || "Message sent successfully");
      setPhone("");
      setResetCount((prev) => prev + 1);
    } catch (err) {
      setError(err?.message || "Something went wrong. Try again.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container" >
      <section className="hero-section">
        <div className="hero">
          <div className="hero__content section">
            <h1>
              Fast, Reliable,
              <br /> & Affordable.
            </h1>
            <p>Over 10,000+ students trust us for their academic success.</p>
          </div>
          <div className="hero__image section">
            <img src={heroImg} alt="Student" />
          </div>
          <div className="hero__form section">
            <div className="hero__whatsapp-row">
              <div className="hero__input">
                <PhoneNumberInput
                  phone={phone}
                  setPhone={setPhone}
                  resetKey={resetCount}
                  countryCode={countryCode}
                  setCountryCode={setCountryCode}
                  setCountryName={setCountryName}
                />
              </div>

              <button
                disabled={isButtonDisabled}
                onClick={handleSubmit}
                className="hero__btn"
              >
                <i className="fab fa-whatsapp"></i>
                {loading ? "Sending..." : "Text Me Now"}
              </button>
            </div>

            {error && (
              <p className={`msg error-text ${error ? "show" : ""}`}>{error}</p>
            )}
            {success && (
              <p className={`msg success-text ${success ? "show" : ""}`}>
                {success}
              </p>
            )}

            <small>
              *Get instant homework help from top tutors—just a WhatsApp message
              away.
              <strong>24/7 support</strong> for all your academic needs!
            </small>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhatsAppCMP;
